import React from 'react';
import { Link } from 'react-router-dom';
import './FeaturedGrid.css';

// "Featured" bento grid: hero tile double-size left, wide tile top-right,
// two small, then a 4-across bottom row. Photo tiles with a dark overlay
// and the card name + price at the bottom.
const FeaturedGrid = ({ listings }) => {
    const items = (listings || []).slice(0, 8);
    if (items.length === 0) return null;

    const top = items.slice(0, 4);
    const bottom = items.slice(4);

    const tile = (l, idx) => {
        const cert = l.cert || {};
        const img = cert.cert_images?.front_image_url;
        const price = Number(l.price);
        const name = cert.card?.name || cert.name || `Cert ${cert.cert_number}`;
        return (
            <Link
                key={l.id || cert.cert_number}
                to={`/listing/${cert.cert_number}`}
                className={`gh-feat-tile gh-feat-${idx}`}
            >
                {img && <img src={img} alt="" loading="lazy" />}
                <span className="gh-feat-shade" aria-hidden="true" />
                <span className="gh-feat-meta">
                    <span className="gh-feat-name">{name}</span>
                    {Number.isFinite(price) && <span className="gh-feat-sub">${price.toFixed(0)}</span>}
                </span>
            </Link>
        );
    };

    return (
        <section className="gh-feat">
            <h2 className="gh-feat-title">Featured</h2>
            <div className="gh-feat-top">
                {top.map((l, i) => tile(l, i + 1))}
            </div>
            {bottom.length > 0 && (
                <div className="gh-feat-bottom">
                    {bottom.map((l, i) => tile(l, i + 5))}
                </div>
            )}
        </section>
    );
};

export default FeaturedGrid;
